// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Async from "./Async.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function reactMapWithDefault(opt, $$default, f) {
  if (opt !== undefined) {
    return Curry._1(f, Caml_option.valFromOption(opt));
  } else {
    return $$default;
  }
}

function reactMap(opt, f) {
  return reactMapWithDefault(opt, null, f);
}

var Opt = {
  let_: Belt_Option.flatMap
};

var let_ = Async.let_;

var mapAsync = Async.mapAsync;

var async = Async.async;

var catchAsync = Async.catchAsync;

var asyncFromResult = Async.asyncFromResult;

var attemptMapAsync = Async.attemptMapAsync;

export {
  let_ ,
  mapAsync ,
  async ,
  catchAsync ,
  asyncFromResult ,
  attemptMapAsync ,
  reactMapWithDefault ,
  reactMap ,
  Opt ,
  
}
/* Async Not a pure module */
